module.exports = __webpack_public_path__ + "static/media/mobilescreen3.de9cd42a.png";